import { useMemo, useState } from "react";
import { X } from "lucide-react";
import { Input } from "@/components/ui/input";

// Searchable multi-select: options = [{ id, label }]
export const EntityPicker = ({ label, options, value, onChange, testId }) => {
  const [q, setQ] = useState("");
  const byId = useMemo(() => Object.fromEntries(options.map(o => [o.id, o])), [options]);
  const matches = useMemo(() => {
    const needle = q.trim().toLowerCase();
    if (!needle) return [];
    return options.filter(o => !value.includes(o.id) && o.label.toLowerCase().includes(needle)).slice(0, 8);
  }, [q, options, value]);

  const add = (id) => { onChange([...value, id]); setQ(""); };
  const remove = (id) => onChange(value.filter(v => v !== id));

  return (
    <div data-testid={testId}>
      <label className="text-sm font-medium">{label}</label>
      {value.length > 0 && (
        <div className="flex flex-wrap gap-1.5 my-1.5">
          {value.map(id => (
            <span key={id} className="inline-flex items-center gap-1 bg-[#009E60]/10 text-[#00704a] text-xs font-medium px-2 py-1" data-testid={`${testId}-chip-${id}`}>
              {byId[id]?.label || id}
              <button type="button" onClick={() => remove(id)} className="hover:text-red-600" data-testid={`${testId}-remove-${id}`}>
                <X className="w-3 h-3" />
              </button>
            </span>
          ))}
        </div>
      )}
      <div className="relative">
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder={`Search ${label.toLowerCase()}...`} className="rounded-none" data-testid={`${testId}-search`} />
        {matches.length > 0 && (
          <div className="absolute z-20 left-0 right-0 bg-white border border-gray-200 shadow-lg max-h-56 overflow-y-auto">
            {matches.map(o => (
              <button type="button" key={o.id} onClick={() => add(o.id)} className="block w-full text-left px-3 py-2 text-sm hover:bg-gray-100" data-testid={`${testId}-option-${o.id}`}>
                {o.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
